<template>
    <div>
        <li
            v-for="item in filteredInstallations"
            :key="item.id"
            class="vrm-nav__items__item vrm-nav__installation"
            :class="{ 'vrm--has-warning': item.alarm, 'vrm--active': $route.params.id === item.id }"
            @click="openMenu(item, $event)"
            @mousedown.middle="openInstallationInNewTab(item)"
        >
            <a class="vrm-nav__items__item__link">
                <span
                    v-tooltip="$t('core.running_on_' + item.device_icon)"
                    :class="getIcon(item.device_icon)"
                    data-tooltip-class="vrm-tooltip--arrow-left vrm-tooltip--light"
                ></span>
                {{ item.name }}
            </a>
            <a class="vrm-nav__items__item__open">
                <span class="sg-vrm-icon_088_plus_12px"></span>
            </a>
        </li>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: {},
})
@AngularDirective('vrm-nav-installation-item')
@AngularLocaleBundle('core')
export default class VrmNavInstallationItem extends Vue {
    @Prop({ type: Array, default: () => [] })
    installations;
    @Prop({ type: String, default: '' })
    searchInstallation;

    @ngInject()
    $filter;

    get filteredInstallations() {
        if (!this.searchInstallation) {
            return this.installations;
        }
        const searchTerm = this.searchInstallation.toLowerCase();
        return this.installations.filter(installation => {
            return (
                installation.name
                    .toString()
                    .toLowerCase()
                    .indexOf(searchTerm) > -1
            );
        });
    }

    getIcon(deviceIcon) {
        return this.$filter('vrmDeviceIcon')(deviceIcon);
    }

    openMenu(item, event) {
        //Control key or command key or middle mouse button
        if (event.ctrlKey || event.metaKey) {
            this.openInstallationInNewTab(item);
        } else {
            this.$router.push({ name: 'base.installation.dashboard', params: { id: item.id } });
            this.$emit('openMenu', 'installation', item, undefined, true);
        }
    }

    openInstallationInNewTab(item) {
        //open in new tab
        const route = `/installation/${item.id}`; // Manually construct the route path
        const fullPath = `${window.location.origin}${route}`;
        window.open(fullPath, '_blank');
    }
}
</script>
